import React from 'react';
import { Document, Page, Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer';
import { PAPER_SIZE } from '../../types/enums';
import moment from 'moment';
import { VisaDocumentProps } from '../types';
import 'moment/locale/fr';
import { getFieldWithEnding } from './utils';
import { registerFonts } from '../../badge/pdf/pdfDocument/pdfStyles';
import { TextWithFontCheck as TFC } from '../../common/components/textWithFontCheck/TextWithFontCheck';
import { useVisaDocumentFR } from './hooks/useVisaDocumentFR';
import PDFUtils from '../../badge/utils/pdfUtils';

Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf',
      fontWeight: 400
    }
  ]
});

Font.register({
  family: 'Roboto-Bold',
  fonts: [{
    src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf',
    fontWeight: 600
  }]
});

const styles = StyleSheet.create({
  container: {
    fontFamily: 'Roboto',
    fontSize: 12,
    paddingLeft: '2.5cm',
    paddingRight: '2.5cm',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column'
  },
  footerImage: {
    minWidth: '596px',
    maxWidth: '596px',
    minHeight: '220px',
    maxHeight: '220px',
    marginTop: 'auto'
  },
  logo: {
    minWidth: '596px',
    maxWidth: '596px',
    minHeight: '86px',
    maxHeight: '86px',
    marginBottom: '10px'
  },
  date: {
    marginBottom: 20
  },
  marginBottom10: {
    marginBottom: 10
  },
  marginBottom20: {
    marginBottom: 20
  },
  marginLeft30: {
    marginLeft: 30
  }
});

export const VisaDocumentFR: React.FC<VisaDocumentProps> = ({
                                                              event, person, company, logoSrc, footerSrc
                                                            }) => {
  registerFonts();
  moment.locale('fr');

  const { startDate, endDate } = useVisaDocumentFR(event.dates);

  return (
    <Document>
      <Page size={PAPER_SIZE.A4}>
        <Image style={styles.logo} src={PDFUtils.returnSrc(logoSrc)} />
        <View style={styles.container}>
          <View>
            <View style={styles.date}>
              <Text>Puteaux, le {moment().format('DD/MM/YYYY')}</Text>
            </View>
            <View>
              <Text style={styles.marginBottom20}>Objet : Lettre d’invitation</Text>
              <Text style={styles.marginBottom10}>Madame, Monsieur,</Text>
              <Text style={styles.marginBottom20}>Le salon <TFC>{event.name}</TFC> se
                tiendra
                du {startDate} au {endDate.toLowerCase()} au <TFC>{event.venue}</TFC>.</Text>
              <Text style={styles.marginBottom20}>En tant qu’organisateur, nous sommes informés du souhait
                de <TFC>{getFieldWithEnding(person.title, ' ')}</TFC>
                <TFC>{person.firstName}</TFC>{' '}
                <TFC>{person.lastName}</TFC>, <TFC>{person.position}</TFC> à
                se
                déplacer dans le cadre de ses activités professionnelles,
                pour se rendre à notre événement.</Text>
              <Text>Voici ci-dessous ces informations :</Text>
              <Text style={styles.marginLeft30}>Société : <TFC>{company.name}</TFC></Text>
              <Text style={styles.marginLeft30}>Adresse : <TFC>{company.address1}</TFC></Text>
              <Text style={styles.marginLeft30}>Code postal : <TFC>{company.postCode}</TFC></Text>
              <Text style={styles.marginLeft30}>Ville : <TFC>{company.city}</TFC></Text>
              <Text style={styles.marginLeft30}>Pays : <TFC>{company.country}</TFC></Text>
              {(person.phoneNumber && <Text style={styles.marginLeft30}>Téléphone : <TFC>{person.phoneNumber}</TFC></Text>) || null}
              <Text style={[styles.marginBottom10, styles.marginLeft30]}>Email : <TFC>{person.email}</TFC></Text>
              <Text style={styles.marginBottom10}>Nous vous saurions gré d’examiner la demande de visa que cette
                personne vous
                présentera.</Text>
              <Text style={styles.marginBottom10}>Nous vous remercions par avance, et vous prions de recevoir, Madame,
                Monsieur, nos
                salutations respectueuses.</Text>
            </View>
            <View>
              <Text>Cordialement,</Text>
              <Text>Le Service Clients.</Text>
            </View>
          </View>
        </View>
        <Image style={styles.footerImage} src={PDFUtils.returnSrc(footerSrc)} />
      </Page>
    </Document>
  );
};
